import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetQueries } from "@typings/api";
import { isEmpty } from "@utils/formatters";
import type { GetCollarLogsResponse } from "./type";

async function getCollarLogs(
  individualId: string,
  query: GetQueries,
): Promise<GetCollarLogsResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    params.append(key, String(value));
  });

  let url = apiPaths.individuals.logs.list(String(individualId));
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetCollarLogsResponse>(url);

  return response.data;
}

export function useGetCollarLogs(
  individualId: string,
  query: GetQueries | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [`fetch-get-individual-collar-logs`, JSON.stringify(query ?? {})],
    () => getCollarLogs(individualId, query ?? {}),
    mergedOptions,
  );
}
